import styled from 'styled-components';

export default styled.div`
  height: 426px;
  overflow-y: scroll;
`;
